// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3826": "0129ab72d18c","5018": "f3aebcddaad9","6230": "1c9fd146d451","9401": "cacd6b4951d2",}[chunkId] + ".css"
}